import { POD_EXPANSION } from './generated-pod-expansion.js';
import { designFor } from './product-designs.js';
import { TEMPORARY_PRODUCTS } from './temporary-product-photos.js';

// Provider-backed expansion still requires a matching official mockup.
export function readyExpansionProducts(exhibition, existing = []) {
  const slugs = new Set(existing.map(product => product.slug));
  return POD_EXPANSION.filter(cfg => {
    if (slugs.has(cfg.slug)) return false;
    const design = designFor(cfg);
    return design.photoSource === 'printful' && design.podSpec?.orderReady === true;
  }).map((cfg, index) => ({
    id: `pod-${cfg.slug}`, slug: cfg.slug, name: cfg.name,
    exhibition_id: exhibition.id, exhibition,
    drop: { name: cfg.collection || 'EXPANSION 001' },
    category: cfg.productType === 'tee' ? 'tee' : cfg.productType === 'tumbler' ? 'tumbler' : 'mug',
    catalog_group: cfg.catalogGroup, price: null, stock_status: 'in_stock',
    purchase_url: null, payment_price_id: null, is_published: true,
    display_order: existing.length + index,
    metadata: { podSlug: cfg.slug, pricingStatus: 'not-configured' },
  }));
}

// Explicit user approval is a separate display permission, not manufacturing
// approval. Museum and Catalog both call this same public collection resolver.
export function publicAdditionalProducts(exhibition, existing = []) {
  const official = readyExpansionProducts(exhibition, existing);
  const slugs = new Set([...existing, ...official].map(p => p.slug));
  const concepts = TEMPORARY_PRODUCTS.filter(cfg => !slugs.has(cfg.slug) && designFor(cfg).photoSource === 'concept')
    .map((cfg, index) => ({
      id: `concept-${cfg.slug}`, slug: cfg.slug, name: cfg.name,
      exhibition_id: exhibition.id, exhibition,
      drop: { name: 'CONCEPT COLLECTION' },
      category: cfg.category, catalog_group: cfg.catalogGroup,
      price: null, stock_status: 'in_stock', purchase_url: null, payment_price_id: null,
      is_published: true, display_order: existing.length + official.length + index,
      short_description: '承認済みのデザインイメージを暫定展示しています。製品仕様・印刷方法・販売価格は調整中です。',
      metadata: { previewOnly: true, mascot: cfg.mascot, manufacturingVerified: false },
    }));
  return [...official, ...concepts];
}
